import http from '@/services/http.service'

const path = 'statements'

export async function setEvaluation(
  moduleId: string,
  statementId: string,
  evaluation: number | null
): Promise<void> {
  if (evaluation == null) return
  await http.post(`${path}/${moduleId}/${statementId}/evaluate/${evaluation}`)
}

export async function setRelevance(
  moduleId: string,
  statementId: string,
  relevant: boolean
): Promise<void> {
  await http.post(`${path}/${moduleId}/${statementId}/relevant/${relevant}`)
}

export default { setEvaluation, setRelevance }
